import { render, staticRenderFns } from "./EstampillasAnmacVenta.vue?vue&type=template&id=4b3efbca&scoped=true&"
import script from "./EstampillasAnmacVenta.vue?vue&type=script&lang=js&"
export * from "./EstampillasAnmacVenta.vue?vue&type=script&lang=js&"
import style0 from "./EstampillasAnmacVenta.vue?vue&type=style&index=0&id=4b3efbca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3efbca",
  null
  
)

export default component.exports